import * as remoteAction from "../remoteAction";

export type GetExchangesActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_EXCHANGES_SUCCESS",
  any
>;
export type GetExchangesActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_EXCHANGES_FAILURE",
  any
>;
export type GetExchangesActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_EXCHANGES_REQUEST",
  any
>;

export interface GetExchangesAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_EXCHANGES_REQUEST";
    success: "GET_EXCHANGES_SUCCESS";
    failure: "GET_EXCHANGES_FAILURE";
  };
}

export function getExchangesAction(): GetExchangesAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_EXCHANGES_FAILURE",
      request: "GET_EXCHANGES_REQUEST",
      success: "GET_EXCHANGES_SUCCESS",
    },
    https: true,
    url: `/rewards/exchanges`,
  };
}
